import {
  Form,
  LoginClasses,
  LoginFormClasses,
  required,
  TextInput,
  useTranslate
} from 'react-admin'
import { Avatar, Button, Card, CardContent, styled } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'
import { useFormContext } from 'react-hook-form'
import { isNil } from 'lodash'
import { isEmpty, trim } from 'lodash/fp'

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  height: '1px',
  alignItems: 'center',
  justifyContent: 'flex-start',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundImage:
    'radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)',

  [`& .${LoginClasses.card}`]: {
    minWidth: 300,
    marginTop: '6em'
  },
  [`& .${LoginClasses.avatar}`]: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center'
  }
}))

export const AccessKey: React.FC<{ setAccessKey: (value: string) => void }> = ({
  setAccessKey
}) => {
  const translate = useTranslate()
  const SubmitButton: React.FC = () => {
    const { getValues } = useFormContext()
    const { accessKey } = getValues()
    const submit = (): void => {
      setAccessKey(trim(accessKey))
    }
    return (
      <Button
        variant="contained"
        onClick={submit}
        type="button"
        color="primary"
        disabled={isNil(accessKey) || isEmpty(accessKey)}
        fullWidth
        className={LoginFormClasses.button}>
        {translate('resources.solarData.get')}
      </Button>
    )
  }
  return (
    <Root>
      <Card className={LoginClasses.card}>
        <div className={LoginClasses.avatar}>
          <Avatar className={LoginClasses.icon}>
            <LockIcon />
          </Avatar>
        </div>
        <Form mode="onChange" noValidate className="RaLoginForm-root">
          <CardContent className={LoginFormClasses.content}>
            <TextInput
              autoFocus
              type="password"
              source="accessKey"
              label={translate('resources.solarData.accessKey')}
              validate={required()}
              fullWidth
            />
            <SubmitButton />
          </CardContent>
        </Form>
      </Card>
    </Root>
  )
}
